import { nullableOptionSchema, optionSchema } from '@/common/schemas/option.schema';
import { z } from 'zod';

export const updateEstablishmentCompanySchema = z.object({
  product_categories: z.array(optionSchema).optional(),
  commercial_manager: optionSchema.optional(),
  commercial_manager_substitute: nullableOptionSchema.optional().nullable(),
  allowed_client_companies_attributes: z.array(optionSchema).optional(),
  observations: z.string().optional(),
  matrix_branch_attributes: z.object({
    payment_advance_daily_interest: z.string().optional(),
  }).optional(),
  time_zone_id: optionSchema.optional(),
  tow_service_available: z.boolean().optional().nullable(),
  ca_module_enabled: z.boolean().optional().nullable(),
  cm_module_enabled: z.boolean().optional().nullable(),
  tmais_module_enabled: z.boolean().optional().nullable(),
  photos: z.array(
    z.object({
      id: z.string(),
      file: z.custom<File | string>().optional().nullable(),
    }),
  ).optional().nullable(),
});

export type UpdateEstablishmentCompanyValidationSchema = z.infer<typeof updateEstablishmentCompanySchema>;
